import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';
import { useLanguage } from '../contexts/LanguageContext';
import ShareButtons from '../components/ShareButtons';

const RankingsPage = () => {
  const [rankings, setRankings] = useState(null);
  const { t, language } = useLanguage();

  useEffect(() => {
    axios.get(`${API}/rankings?season=1`).then(res => setRankings(res.data)).catch(console.error);
  }, []);

  const categories = [
    { key: 'top_scorers', label: t('topScorers'), stat: language === 'gr' ? 'Πόντοι' : 'PTS', field: 'points', color: '#F97316' },
    { key: 'top_rebounders', label: t('topRebounders'), stat: language === 'gr' ? 'Ριμπάουντ' : 'REB', field: 'rebounds', color: '#1E3A5F' },
    { key: 'top_steals', label: t('topSteals'), stat: language === 'gr' ? 'Κλεψίματα' : 'STL', field: 'steals', color: '#7C3AED' },
  ];

  const hasData = rankings && categories.some(c => rankings[c.key]?.length > 0);

  return (
    <div className="max-w-7xl mx-auto px-4 py-12" data-testid="rankings-page">
      <div className="text-center mb-12">
        <h1 className="section-title mb-2">{t('rankingsTitle')}</h1>
        <p className="text-slate-600">{language === 'gr' ? 'Οι κορυφαίες της 1ης σεζόν' : 'Top players of Season 1'}</p>
      </div>

      {!hasData ? (
        <p className="text-slate-500 text-center py-12">{t('noRankings')}</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map(cat => (
            rankings[cat.key]?.length > 0 && (
              <div key={cat.key} className="card overflow-hidden" data-testid={`ranking-${cat.key}`}>
                <div className="p-4 text-white font-display font-bold" style={{ backgroundColor: cat.color }}>
                  {cat.label}
                </div>
                <div className="divide-y divide-slate-100">
                  {rankings[cat.key].map((player, i) => (
                    <div key={i} className="flex items-center gap-3 p-4" data-testid={`rank-${cat.key}-${i}`}>
                      <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${i === 0 ? 'bg-yellow-100 text-yellow-700' : i === 1 ? 'bg-slate-200 text-slate-600' : i === 2 ? 'bg-orange-100 text-orange-700' : 'bg-slate-50 text-slate-500'}`}>
                        {i + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm truncate">{player.name}</p>
                        <p className="text-xs text-slate-500 flex items-center gap-1">
                          <span className="w-2 h-2 rounded-full inline-block" style={{ backgroundColor: player.team_color }}></span>
                          {player.team_name}
                        </p>
                      </div>
                      <span className="font-display font-bold text-lg" style={{ color: cat.color }}>
                        {player[cat.field]}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )
          ))}
        </div>
      )}
      <div className="mt-4 flex justify-end">
        <ShareButtons title={language === 'gr' ? 'Κατάταξη Παικτριών WBLA' : 'WBLA Player Rankings'} />
      </div>
    </div>
  );
};

export default RankingsPage;
